import { useEffect, useState } from "react";
import {
  IonCol,
  IonContent,
  IonGrid,
  IonItem,
  IonPage,
  IonRow,
  IonTitle,
} from "@ionic/react";
import { IEneatipo } from "../../entities/IEneatipo";
import { Loading } from "../../components/Loading";
import Axios from "axios";
import config from "../../config.json";

export const MainEneatipo = () => {
  const [data, setData] = useState<IEneatipo[]>([]);

  useEffect(() => {
    if (!data.length) {
      Axios.get<IEneatipo[]>(config.api.eneatipo).then((x) => setData(x.data));
    }
  });

  return (
    <IonPage>
      <IonContent fullscreen>
        <Loading loading={!data.length}>
          {data.map((x) => {
            let header =
              process.env.PUBLIC_URL + `/imgs/eneatipos/titular/${x.id}.jpg`;

            return (
              <IonItem key={x.id} routerLink={"/Eneatipo/" + x.id}>
                <IonGrid>
                  <IonRow>
                    <IonCol style={{ textAlign: "right" }}>
                      <img src={header} style={{ width: "50vh" }} />
                    </IonCol>
                    <IonCol
                      style={{
                        marginTop: "6%",
                        color: "var(--ion-color-secondary-shade)",
                      }}
                    >
                      <IonTitle>{x.nombre}</IonTitle>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </IonItem>
            );
          })}
        </Loading>
      </IonContent>
    </IonPage>
  );
};
